<template>
    <div class="instrumentTime">
        <div class="layout-page-box">
            <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
                <el-form-item label="划扣项目">
                    <el-select ref='mySelected' @focus="focus(4)" clearable v-model="filters.musProjectNameId" placeholder="选择划扣项目" filterable :filter-method="projectMatch" multiple>
                        <el-option v-for="(item) in projectList" :key="item.id" :label="item.project" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="耗材名称">
                    <el-input v-model.trim="filters.materialName" clearable placeholder="请输入项目类别"></el-input>
                </el-form-item>
                <el-form-item label="医生">
                    <el-select v-model="filters.doctorName" placeholder="请选择医生" multiple filterable remote clearable @focus="focus(1)" :filter-method="doctorMatch">
                        <el-option v-for="item in newList1" :key="item.menuName" :label="item.menuName" :value="item.menuName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="医助">
                    <el-select v-model="filters.aideName" placeholder="请选择医助" multiple filterable remote clearable @focus="focus(2)" :filter-method="assistMatch">
                        <el-option v-for="item in newList2" :key="item.menuName" :label="item.menuName" :value="item.menuName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="护士">
                    <el-select v-model="filters.nurseName" placeholder="请选择护士" multiple filterable remote clearable @focus="focus(3)" :filter-method="nurseMatch">
                        <el-option v-for="item in newList3" :key="item.menuName" :label="item.menuName" :value="item.menuName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="卡号">
                    <div class="no">
                        <el-select @blur.capture.native="onBlur('cadCode')" @change.capture.native="onInput($event,'cadCode')" :popper-append-to-body="false" clearable v-model="filters.cadCode" placeholder="请输入卡号" multiple allow-create filterable default-first-option></el-select>
                    </div>
                </el-form-item>
                <el-form-item label="姓名">
                    <div class="no">
                        <el-select @blur.capture.native="onBlur('sknName')" @change.capture.native="onInput($event,'sknName')" :popper-append-to-body="false" clearable v-model="filters.sknName" placeholder="请输入姓名" multiple filterable allow-create></el-select>
                    </div>
                </el-form-item>
                <el-form-item label="手机号">
                    <div class="no">
                        <el-select @blur.capture.native="onBlur('mobile')" @change.capture.native="onInput($event,'mobile')" :popper-append-to-body="false" clearable v-model="filters.mobile" placeholder="请输入手机号" multiple allow-create filterable default-first-option></el-select>
                    </div>
                </el-form-item>
                <el-form-item label="划扣时间">
                    <el-date-picker v-model="filters.startTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search" size="small">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="layout-page-box">
            <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" :height="tableHeight" :header-cell-style="{color:'#626365'}">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column sortable prop="sknDate" label="日期"></el-table-column>
                <el-table-column sortable prop="earName" label="院区"></el-table-column>
                <el-table-column sortable prop="caseCode" label="病历号" align="center"></el-table-column>
                <el-table-column sortable prop="cadCode" label="卡号"></el-table-column>
                <el-table-column sortable prop="sknName" label="姓名"></el-table-column>
                <el-table-column sortable prop="musProjectName" label="划扣项目"></el-table-column>
                <el-table-column sortable prop="musContent" label="划扣次数"></el-table-column>
                <el-table-column sortable prop="musReplenish" label="划扣补充"></el-table-column>
                <el-table-column sortable prop="doctorName" label="医生"></el-table-column>
                <el-table-column sortable prop="aideName" label="医助"></el-table-column>
                <el-table-column sortable prop="nurseName" label="护士"></el-table-column>
                <!-- <el-table-column sortable prop="musAmt" label="当日划扣金额"></el-table-column> -->
                <el-table-column sortable prop="materialName" label="耗材名称">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.materialList" :key="index">
                            <span v-if="item.materialName!=' '">{{item.materialName}}</span>
                            <span v-else style="opacity: 0;">{{'/'}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column sortable prop="materialSpec" label="耗材规格">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.materialList" :key="index">
                            <span v-if="item.materialSpec!=' '">{{item.materialSpec}}</span>
                            <span v-else style="opacity: 0;">{{'/'}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column sortable prop="mesoderm" label="中胚层病历">
                    <template slot-scope="scope">
                        <div v-if="scope.row.mesoderm==false">无</div>
                        <div v-if="scope.row.mesoderm==true">有</div>
                    </template>
                </el-table-column>
                <el-table-column sortable prop="laser" label="激光病历">
                    <template slot-scope="scope">
                        <div v-if="scope.row.laser==false">无</div>
                        <div v-if="scope.row.laser==true">有</div>
                    </template>
                </el-table-column>
                <el-table-column sortable prop="injection" label="注射病历">
                    <template slot-scope="scope">
                        <div v-if="scope.row.injection==false">无</div>
                        <div v-if="scope.row.injection==true">有</div>
                    </template>
                </el-table-column>
                <!-- <el-table-column sortable prop="remark" label="备注"></el-table-column>
                <el-table-column sortable prop="projectRemark" label="产品备注"></el-table-column>
                <el-table-column sortable prop="manufacturers" label="厂家">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.materialList" :key="index">
                            <span v-if="item.manufacturers!=' '">{{item.manufacturers}}</span>
                            <span v-else style="opacity: 0;">{{'/'}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column sortable prop="number" label="数量">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.materialList" :key="index">
                            <span v-if="item.number!=' '">{{item.number}}</span>
                            <span v-else style="opacity: 0;">{{'/'}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column sortable prop="actualUse" label="实际使用">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.materialList" :key="index">
                            <span v-if="item.actualUse!=' '">{{item.actualUse}}</span>
                            <span v-else style="opacity: 0;">{{'/'}}</span>
                        </div>
                    </template>
                </el-table-column> -->
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">创建病历</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
            </el-pagination>
        </div>
        <!-- 新增编辑弹框 -->
        <div class="father">
            <el-dialog title="新增病例-美容皮肤科(中胚层)" v-if="dialogFormVisible" :visible.sync="dialogFormVisible" center class="dialogItem" :close-on-click-modal="false">
                <child :formData="formData" @close="close"></child>
            </el-dialog>
            <el-dialog title="新增病例-美容皮肤科(激光)" v-if="dialogChild" :visible.sync="dialogChild" center class="dialogItem" :close-on-click-modal="false">
                <brother :formData="formData" @close1="close1"></brother>
            </el-dialog>
            <el-dialog title="新增病例-美容皮肤科(注射)" v-if="dialogInject" :visible.sync="dialogInject" center class="dialogItem" :close-on-click-modal="false">
                <inject :formData="formData" @close2="close2"></inject>
            </el-dialog>
        </div>
        <el-dialog title="选择新增病历类型" :visible.sync="dialog" center class="dialogItem" :close-on-click-modal="false">
            <div class="flex">
                <el-button type="primary" @click="tap(1)" plain>美容皮肤科门诊病历(中胚层)</el-button>
                <el-button type="primary" @click="tap(2)" plain>美容皮肤科门诊病历(激光)</el-button>
                <el-button type="primary" @click="tap(3)" plain>美容皮肤科门诊病历(注射)</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import child from './child'
import brother from './brother'
import inject from './inject'
export default {
    name: "buckle",
    computed: {
        ...mapGetters(['productOptions', 'nurseList', 'anesList', 'doctorList', 'assistantList']),
    },
    components: {
        child,
        brother,
        inject,
    },
    data() {
        return {
            title: '',
            filters: {
                types: '',
                pagination: {
                    page: 1,
                    limit: 10,
                    total: 0
                },
                startTime: [_g.getMonths()[0], _g.getMonths()[1]],
                endTime: '',
            },
            tableData: [],
            multipleSelection: [],
            dialogFormVisible: false,
            formData: {},
            tableHeight: "",
            isId: '',
            newList1: [],
            newList2: [],
            newList3: [],
            projectList: [],
            dialog: false,
            dialogChild: false,
            dialogInject: false,
        }
    },
    created() {
        this.tableHeight = document.documentElement.clientHeight - 280
    },
    mounted() {
        /*this.init();*/
        this.$store.dispatch('getIdList')
        this.$store.dispatch('getDataList')
        this.query(this.filters.pagination.page);
    },
    watch: {
        $route(to, from) {
            if (this.activatedFlag) {
                this.query(this.filters.pagination.page);
            }
        },
    },
    methods: {
        close() {
            this.dialogFormVisible = false
            this.dialog = false
        },
        close1() {
            this.dialogChild = false
            this.dialog = false
        },
        close2() {
            this.dialogInject = false
            this.dialog = false
        },
        tap(val) {
            this.formData.skinDisease = 0
            this.formData.diabetes = 0
            this.formData.autoimmuneDisease = 0
            this.formData.coagulationDisorders = 0
            this.formData.allergyHistory = 0
            this.formData.preparationPregnant = 0
            this.formData.anaesthesiaMode = 0
            this.formData.period = 0
            this.formData.pregnant = 0
            this.formData.sucklingPeriod = 0
            this.formData.isFirst = 0
            if (val == 1) {
                this.dialogFormVisible = true
                this.formData.treatmentPosition = []
                this.formData.treatmentOpinions = []
            } else if (val == 2) {
                this.dialogChild = true
                this.formData.treatmentPosition = ''
            } else if (val == 3) {
                this.dialogInject = true
                this.formData.injectionDiagnosisNo = []
                this.formData.injectionTreatment = []
                this.formData.injectionType1 = []
                this.formData.injectionType2 = []
                this.formData.injectionType3 = []
                this.formData.injectionType4 = []
                this.formData.injectionPosition = []
            }
        },
        handleEdit(index, row) {
            this.dialog = true
            let querys = {
                id: row.id,
                sknMaterialId: row.sknMaterialId,
            }
            api.request('/skn/findMusInformationById', querys, (res) => {
                this.formData = res.data
                this.formData.instrumentNo = _g.turnNum(this.formData.instrumentNo)
            })
        },
        focus(val) {
            if (val == 1) {
                this.newList1 = this.doctorList
            } else if (val == 2) {
                this.newList2 = this.assistantList
            } else if (val == 3) {
                this.newList3 = this.nurseList
            } else if (val == 4) {
                this.projectList = this.productOptions
            }
        },
        doctorMatch(val) {
            this.newList1 = _g.paramMatch(this.doctorList, this.newList1, val, 'menuName')
        },
        assistMatch(val) {
            this.newList2 = _g.paramMatch(this.assistantList, this.newList2, val, 'menuName')
        },
        nurseMatch(val) {
            this.newList3 = _g.paramMatch(this.nurseList, this.newList3, val, 'menuName')
        },
        projectMatch(val) {
            this.projectList = _g.paramMatch(this.productOptions, this.projectList, val, 'project')
        },
        search() {
            this.filters.pagination.page = 1
            this.refresh()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        pageChanged(page) {
            this.filters.pagination.page = page
            this.refresh()
        },
        handleSizeChange(sizes) {
            this.filters.pagination.limit = sizes
            this.refresh()
        },
        refresh() {
            router.push({
                path: this.$route.path,
                query: _.merge({}, this.$route.query, {
                    __query: JSON.stringify(this.pagination)
                }, {
                        random: Math.random()
                    })
            })
        },


        // 查询数据列表
        query(page) {
            // console.log(this.filters.startTime)
            var querys = {
                startTime: '',
                endTime: '',
                page: page,
                size: this.filters.pagination.limit,
                musProjectNameId: this.filters.musProjectNameId.toString(),
                doctorName: this.filters.doctorName.toString(),
                aideName: this.filters.aideName.toString(),
                nurseName: this.filters.nurseName.toString(),
                materialName: this.filters.materialName,
                cadCode: this.filters.cadCode.toString(),
                sknName: this.filters.sknName.toString(),
                mobile: this.filters.mobile.toString(),
            }
            if (this.filters.startTime) {
                querys.startTime = this.filters.startTime[0]
                querys.endTime = this.filters.startTime[1]
            }
            // console.log(querys)
            api.request('/skn/findMusInformationPage', querys, (res) => {
                // console.log(res)
                var data = res.data.list
                this.tableData = data
                this.filters.pagination.total = parseInt(res.data.count)
            })
        },
        // 姓名多选款
        onBlur(val) {
            if (val == 'sknName') {
                if (this.inputName != '' && !this.filters.sknName.includes(this.inputName)) {
                    this.filters.sknName.push(this.inputName)
                    this.inputName = ''
                }
            } else if (val == 'cadCode') {
                if (this.inputCode != '' && !this.filters.cadCode.includes(this.inputCode)) {
                    this.filters.cadCode.push(this.inputCode)
                    this.inputCode = ''
                }
            } else if (val == 'mobile' && !this.filters.mobile.includes(this.inputMobile)) {
                if (this.inputMobile != '') {
                    this.filters.mobile.push(this.inputMobile)
                    this.inputMobile = ''
                }
            }
        },
        onInput(index, val) {
            if (index.target.value != '') {
                if (val == 'sknName') {
                    this.inputName = index.target.value
                } else if (val == 'cadCode') {
                    this.inputCode = index.target.value
                } else if (val == 'mobile') {
                    this.inputMobile = index.target.value
                }
            }
        },
    },
}
</script>
<style scoped>
@import "../../assets/css/main.css";
.father >>> .el-dialog {
  width: 90% !important;
}
.flex {
  display: flex;
  justify-content: center;
}
.no >>> .el-select-dropdown {
  display: none;
}
</style>